/** @jsx jsx */
import { jsx, css } from '@emotion/react'
import { Grid } from '@mui/material'
import React from 'react'
import stepsIcon from '../assets/steps.png'
import valueInterpolateMapping from '../valueInterpolateMapping'

interface Props {
  pathPosition: number
  isEven: boolean
}

const GOING_DOWN_PERCENT = 77
const SELECTED_ITEM_PERCENT = 87

function StepsPosition(props: Props) {
  const { pathPosition, isEven } = props

  // let sideOffset = pathPosition + 9
  // let sideOffset = pathPosition * 1.17
  let downEffect = pathPosition - GOING_DOWN_PERCENT // 77 is going down moment
  if (downEffect < 0) downEffect = 0

  let topOffset = valueInterpolateMapping({
    inValues: [0, 10, 23],
    outValues: [-5, 24, 52],
    value: downEffect,
  })

  let sideOffset = valueInterpolateMapping({
    inValues: [0, GOING_DOWN_PERCENT, SELECTED_ITEM_PERCENT, 100],
    outValues: [0, 90.5, 97, 90.5],
    value: pathPosition,
  })

  let offsetStyles: React.CSSProperties = {}
  offsetStyles.top = `${topOffset}px`

  const sideOffsetStyle = `${sideOffset}%`

  if (isEven) {
    offsetStyles.right = sideOffsetStyle
  } else {
    offsetStyles.left = sideOffsetStyle
  }

  return (
    <Grid
      container
      justifyContent={'center'}
      alignItems={'center'}
      css={css`
        width: 33px;
        height: 33px;
        border-radius: 50%;
        background-color: #f9b22d;
        position: absolute;
        z-index: 10;
        //transform: scaleY(-1);
        top: -4px;
        right: 0;
        //opacity: 0.7;
        transform: translateX(-13px);
      `}
      style={offsetStyles}
    >
      <img
        alt={'steps'}
        src={stepsIcon}
        css={css`
          width: 18px;
          height: 15px;
          object-fit: contain;
        `}
      />
    </Grid>
  )
}

export default StepsPosition
